import { render, staticRenderFns } from "./downloadable-attachment.vue?vue&type=template&id=1913c8a9&scoped=true&"
import script from "./downloadable-attachment.ts?vue&type=script&lang=ts&"
export * from "./downloadable-attachment.ts?vue&type=script&lang=ts&"
import style0 from "./downloadable-attachment.scss?vue&type=style&index=0&id=1913c8a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1913c8a9",
  null
  
)

export default component.exports